import React, { Component } from 'react';

import {
  addDays,
  subDays
} from 'date-fns';

import { dateToDDMMYYYY, getServerDate } from '../../../../utils';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from 'recharts';

import {
  BranchHistoryIcon,
  CalendarAltIcon
} from '../../../../components/icons';

import PieLabel from '../../../../components/dashboard/PieLabel';

import VenueVisitors from './VenueVisitors';
import DatePickerFilter from './DatePickerFilter';

const colors = ['#0043ff', '#00d1b2', '#ff424b', '#23527c', '#7571ff', '#4267b2', '#d6249f', '#E8770C', '#D1C000', '#8D00DE' ];

class CustomerBehaviorChart extends Component {

  constructor(props) {
    super(props);
    const {
      dashVideo = false
    } = props;

    const CURRDATE = addDays(getServerDate(), -1);

    this.state = {
      isLoading: false,
      typeChart: 'DAILY',
      filterRanges: {
        startDate: addDays(CURRDATE, -13),
        endDate: CURRDATE,
        key: 'selectionRange1'
      },
      dash: {
        header: { venues: [] },
        data: []
      },
      dashVideo
    }
  }

  _changeDateFilter = () => (date) => {
    this.setState({
      filterRanges: {
        startDate: subDays(date, 7),
        endDate: date,
        key: 'selectionRange1'
      }
    }, () => {
      this.loaddata();
    });
  }

  loaddata = () => {
    this.setState({ isLoading: true }, () => {
      const { filterRanges } = this.state;
      this.props.loadVenuePeopleCount(filterRanges.startDate, filterRanges.endDate)
        .then(result => {
          this.setState({ isLoading: false, dash: result });
        });
    });
  }


  _showHistory = () => {
    const { viewOptions, shopId, site } = this.props;
    const { isLoading, filterRanges, dash, dashVideo } = this.state;
    if(isLoading)
      return;

    this.props.showMore(<VenueVisitors
      viewOptions={viewOptions}
      filterRanges={filterRanges}
      site={site}
      dash={dash}
      shopId={shopId}
      dashVideo={dashVideo}
      loadData={this.props.loadVenuePeopleCount}
    />);
  }

  _renderDatePickerLabel = () => {
    const { endDate } = this.state.filterRanges;
    return <div style={{ display: 'flex', justifyContent: 'center' }}>
      <span
        className="button is-large has-text-left is-white card-footer-item is-radiusless is-shadowless is-bordless"
        style={{
          borderRight: 'none',
          maxWidth: '100%',
          justifyContent: 'center'
        }}
      >
        <CalendarAltIcon />
        <span>Top 5 em <b>{dateToDDMMYYYY(endDate)}</b></span>
      </span>
    </div>
  }

  componentDidMount() {
    this.loaddata();
  }

  render() {

    const {
      isLoading,
      dash
    } = this.state;

    const {
      header={ info_date: null, venues: [], venuesInfo: [] }
    } = dash;

    const topFive = header.venues
      .sort((a, b) => b.visitorsCount - a.visitorsCount)
      .slice(0, 5)
      .map((venue, index) => ({
        id: venue.venueid,
        col: index,
        name: venue.name,
        rate: venue.conversionRate,
        value: venue.visitorsCount
      }));

    return <div style={{ width: '100%' }} className="card">
      <header className="card-header" style={{ borderBottom: '1px solid #eee', padding: '10px', justifyContent: 'space-between' }}> 
        <div className="title is-5 is-marginless">
          Atratividade
        </div>
      </header>
      
      <div className="card-content">
        <div className="tile is-ancestor">
          <div className="tile is-12 is-vertical is-parent">
            <div className="tile is-vertical is-parent has-text-centered">
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {header.info_date
                  && <DatePickerFilter 
                    renderLabel={this._renderDatePickerLabel}
                    className={'top-to-down-right'}
                    changeDates={this._changeDateFilter()}
                    currDate={header.info_date}
                  />}
              </div>

              {isLoading
                ? <div className="has-text-centered" style={{ height:300, paddingTop: '70px' }}>
                    <span>
                      <span className="button is-loading is-large is-bordless" />
                      <p className="subtitle is-5">Aguarde, carregando...</p>
                    </span>
                  </div>
                : topFive.filter(top => top.value !== 0).length === 0
                  ? <div className="has-text-centered" style={{ height:300, paddingTop: '70px' }}>
                    <span>
                      <p className="subtitle is-5 has-text-grey-light">Sem dados para a data escolhida.</p>
                    </span>
                  </div>
                  : <ResponsiveContainer className="chart_justifycenter" width="100%" height={400}>
                      <TwoLevelPieChart data={topFive} />
                    </ResponsiveContainer>}
              
              <p className="help">Este é o gráfico pizza que indica o top cinco de áreas da sua loja.</p>
              <p className="help">Isso significa que essas são as cinco que mais tiveram visitantes</p>
            </div>
          </div> 
        </div>
      </div>
      <footer className="card-footer">
        <span
          className="button has-text-left is-white card-footer-item is-radiusless is-shadowless is-bordless"
          style={{ borderRight: 'none' }}
          onClick={this._showHistory} >
          <BranchHistoryIcon />
          <span>Ver histórico</span>
        </span>
        <span className="card-footer-item" style={{ borderRight: 'none' }}>
        </span>
        <span className="card-footer-item" style={{ borderRight: 'none' }}>
        </span>
        <span className="card-footer-item" style={{ borderRight: 'none' }}>
        </span>
      </footer>
    </div>
  }
}


class TwoLevelPieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  renderActiveShape = (props) => {
    const { col, name, rate } = props;
    const primaryLabel = `${col+1}º - ${name}`,
      secondaryLabel = `${rate}% dos visitantes`,
      primaryMiddleText = `TOP 5`,
      secondaryMiddleText = `ENGAJAMENTOS`,
      opacity =  1;

    return (<PieLabel {...props}
      col={col}
      primaryLabel={primaryLabel}
      secondaryLabel={secondaryLabel}
      primaryMiddleText={primaryMiddleText}
      secondaryMiddleText={secondaryMiddleText}
      opacity={opacity}
    />);
  };

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  }

	render () {
    const { data } = this.props;
  	return (
    	<PieChart width={950} height={400}>
        <Pie 
          activeIndex={this.state.activeIndex}
          activeShape={this.renderActiveShape}
          data={data} 
          cx={460} 
          cy={200}
          innerRadius={80}
          outerRadius={100}
          dataKey="rate"
          onMouseEnter={this.onPieEnter}
        >
          {
            data.map((entry, index) => <Cell key={`celpie-${index}`} fillOpacity={1} fill={colors[entry.col]}/>)
          }
        </Pie>
       </PieChart>
    );
  }
}

export default (CustomerBehaviorChart);